import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import GetStarted from "./sections/GetStarted/GetStarted";
import FeaturesBanner from "../../components/FeaturesBanner/FeaturesBanner";
import "./Home.css";

export default function Home() {
  const { lang } = useLanguage();
  const isAr = lang === "ar";

  return (
    <div className="home-page" dir={isAr ? "rtl" : "ltr"}>
      <div className="container py-4">
        <GetStarted />
        <FeaturesBanner />
      </div>
    </div>
  );
}
